// store/sidebarStore.ts
import { makeAutoObservable } from "mobx";

class SidebarStore {
  canCreateNewRequest = false;
  owesPayment = false;

  constructor() {
    makeAutoObservable(this);
  }

  setCanCreateNewRequest(value: boolean) {
    this.canCreateNewRequest = value;
  }

  setOwesPayment(value: boolean) {
    this.owesPayment = value;
  }
}

export const sidebarStore = new SidebarStore();
